import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { PartnerAccount } from 'app/interfaces/partner-account.interface';

@Component({
    selector: 'app-partners-contact-modal',
    templateUrl: './partners-contact-modal.component.html',
    styleUrls: ['./partners-contact-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        ButtonComponent
    ]
})
export class PartnersContactModalComponent {
    @Input() partner: PartnerAccount;
    @Output() close = new EventEmitter<void>();

    onClose(): void {
        this.close.emit();
    }
}
